import React, { useEffect, useState } from "react";

import FormControl from "@material-ui/core/FormControl";
import { Controller } from "react-hook-form";
import Select from 'react-select';

import { FormHelperText } from '@mui/material';

import { customStylesMultiSelect } from "../StyledComponent";

export const MultipleSelectTypeInput = ({
  name,
  label,
  control,
  defaultValue,
  placeholder,
  children,
  errors,
  rules,
  height,
  width,
  onChange,
  selectArray = [],
  getValues,
  ...props
}) => {


  const [arrayValue, setArrayValue] = useState()

  let languageOptions;
  //maping selectArray to make it compatobale with the Select component Options input
  if (getValues && getValues.length > 0) {
    languageOptions = getValues?.map(language => ({
      label: language,
      value: language
    }));
  }


  useEffect(() => {
    setArrayValue(languageOptions);
  }, [getValues]);

  return (
    <div className="flex flex-col gap-2 ">
      <FormControl sx={{ m: 1 }}>
        <label >{label}</label>
        <Controller
          name={name}
          control={control}
          defaultValue={defaultValue}
          rules={rules}
          render={({ field }) => (
            <Select
              {...field}
              placeholder={placeholder}
              closeMenuOnSelect={false}
              options={selectArray}
              onChange={
                (value, a) => {
                  const filteredValue = value?.map((item) => item.value);
                  field.onChange(filteredValue)
                  setArrayValue(value)
                }
              }
              isMulti
              styles={customStylesMultiSelect}
              value={arrayValue || []}
            />
          )}
        />
        {errors[name] && <FormHelperText>{errors[name].message}</FormHelperText>}
      </FormControl>
    </div>
  );
};
